import { Injectable } from '@angular/core';

@Injectable()
export class AuthorizationConfig {
  policies: Object = {}

  constructor(config?: Partial<AuthorizationConfig>) {
    Object.assign(this, config)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/auth/authorization.config.ts